import React from 'react';
import { S2Checkbox } from 'apps/sigma2-ui/src/components/ui/Checkbox';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { replaceTextColor } from 'apps/sigma2-ui/src/components/ui/Typography';
import { DataSetRubricMappingComponent } from 'apps/sigma2-ui/src/data-wizard/components/DataSetRubricMappingComponent';
import { createResumeGradingRubric } from 'apps/sigma2-ui/src/data-wizard/components/DataSetRubricMappingComponent';
import { ResumeQualityScoreRubric } from 'libs/end-to-end/src/types/resume-parser/resume-quality-score-rubric';
import { AllowedOpenAiModels } from 'libs/end-to-end/src/types/databases/data-sets/data-set-resume-rubric';
import { SimpleSelect } from 'apps/sigma2-ui/src/components/ui/SelectComponent/SimpleSelect';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

interface ResumeGradingOptionsProps {
  isResumeGradingEnabled: boolean;
  setIsResumeGradingEnabled: (value: boolean) => void;
  openAiModel: AllowedOpenAiModels;
  setOpenAiModel: (value: AllowedOpenAiModels) => void;
  resumeGradingRubric: ResumeQualityScoreRubric[];
  setResumeGradingRubric: (rubric: ResumeQualityScoreRubric[]) => void;
}

export const ResumeGradingOptions: React.FC<ResumeGradingOptionsProps> = ({
  isResumeGradingEnabled,
  setIsResumeGradingEnabled,
  openAiModel,
  setOpenAiModel,
  resumeGradingRubric,
  setResumeGradingRubric,
}) => {
  const language = useLanguage();

  const selectOpenAiModel = (model: string) => {
    const parsedModel = AllowedOpenAiModels.safeParse(model);
    if (parsedModel.success) {
      setOpenAiModel(parsedModel.data);
    }
  };
  return (
    <>
      <S2Checkbox
        checked={isResumeGradingEnabled}
        onChange={() => {
          setIsResumeGradingEnabled(!isResumeGradingEnabled);
        }}
      >
        Enable Resume Grading
      </S2Checkbox>

      {isResumeGradingEnabled && (
        <>
          <div className="mt-4 mb-4">
            <label className="block mb-1 text-sm font-bold">
              OpenAI Model
              <select
                className="form-select block mb-1 text-sm font-bold"
                value={openAiModel}
                onChange={(e) => selectOpenAiModel(e.target.value)}
              >
                {AllowedOpenAiModels.options.map((model) => (
                  <option key={model} value={model}>
                    {model}
                  </option>
                ))}
              </select>
            </label>
          </div>

          <DataSetRubricMappingComponent
            mapping={resumeGradingRubric}
            setMapping={setResumeGradingRubric}
            titleComponent={
              <S2Typography
                translatedContent={language.dataSetResumeGradingRubricTitle()}
                variant={'headline-5'}
              />
            }
            descriptionComponent={
              <S2Typography
                translatedContent={language.dataSetResumeGradingRubricDescription()}
                variant={'body-6'}
              />
            }
            itemDisplayField="score_key"
            onAddItem={createResumeGradingRubric}
          />
        </>
      )}

      {isResumeGradingEnabled && resumeGradingRubric.length === 0 && (
        <S2Typography
          variant={'body-7'}
          translatedContent={language.dataSetRubricOneQuestionRequired()}
          dangerouslyOverrideClassNameFn={replaceTextColor('text-red-700')}
        />
      )}
    </>
  );
};
